"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimulatorConnector = void 0;
const IConnection_1 = require("../IConnection");
const DhtRpc_1 = require("../../../generated/packages/dht/protos/DhtRpc");
const utils_1 = require("@streamr/utils");
const SimulatorConnection_1 = require("./SimulatorConnection");
const identifiers_1 = require("../../identifiers");
const Handshaker_1 = require("../Handshaker");
const PendingConnection_1 = require("../PendingConnection");
const logger = new utils_1.Logger(module);
class SimulatorConnector {
    connectingConnections = new Map();
    stopped = false;
    localPeerDescriptor;
    simulator;
    onNewConnection;
    constructor(localPeerDescriptor, simulator, onNewConnection) {
        this.localPeerDescriptor = localPeerDescriptor;
        this.simulator = simulator;
        this.onNewConnection = onNewConnection;
    }
    connect(targetPeerDescriptor) {
        logger.trace('connect() ' + (0, identifiers_1.toNodeId)(targetPeerDescriptor));
        const nodeId = (0, identifiers_1.toNodeId)(targetPeerDescriptor);
        const existingConnection = this.connectingConnections.get(nodeId);
        if (existingConnection) {
            return existingConnection;
        }
        const connection = new SimulatorConnection_1.SimulatorConnection(this.localPeerDescriptor, targetPeerDescriptor, IConnection_1.ConnectionType.SIMULATOR_CLIENT, this.simulator);
        const pendingConnection = new PendingConnection_1.PendingConnection(targetPeerDescriptor);
        (0, Handshaker_1.createOutgoingHandshaker)(this.localPeerDescriptor, pendingConnection, connection, targetPeerDescriptor);
        this.connectingConnections.set(nodeId, pendingConnection);
        const delFunc = () => {
            this.connectingConnections.delete(nodeId);
            connection.off('disconnected', delFunc);
            pendingConnection.off('connected', delFunc);
            pendingConnection.off('disconnected', delFunc);
        };
        connection.once('disconnected', delFunc);
        pendingConnection.once('connected', delFunc);
        pendingConnection.once('disconnected', delFunc);
        connection.connect();
        return pendingConnection;
    }
    getPeerDescriptor() {
        return this.localPeerDescriptor;
    }
    handleIncomingConnection(sourceConnection) {
        // connection is incoming, so remotePeerDescriptor is localPeerDescriptor
        const remotePeerDescriptor = sourceConnection.localPeerDescriptor;
        const remoteNodeId = (0, identifiers_1.toNodeId)(sourceConnection.localPeerDescriptor);
        logger.trace(remoteNodeId + ' incoming connection, stopped: ' + this.stopped);
        if (this.stopped) {
            return;
        }
        const connection = new SimulatorConnection_1.SimulatorConnection(this.localPeerDescriptor, remotePeerDescriptor, IConnection_1.ConnectionType.SIMULATOR_SERVER, this.simulator);
        const pendingConnection = new PendingConnection_1.PendingConnection(remotePeerDescriptor);
        const handshaker = (0, Handshaker_1.createIncomingHandshaker)(this.localPeerDescriptor, pendingConnection, connection);
        logger.trace('connected');
        handshaker.once('handshakeRequest', () => {
            logger.trace(remoteNodeId + ' incoming handshake request');
            if (this.onNewConnection(pendingConnection)) {
                logger.trace(remoteNodeId + ' calling acceptHandshake');
                (0, Handshaker_1.acceptHandshake)(handshaker, pendingConnection, connection);
            }
            else {
                (0, Handshaker_1.rejectHandshake)(pendingConnection, connection, handshaker, DhtRpc_1.HandshakeError.DUPLICATE_CONNECTION);
            }
        });
        this.simulator.accept(sourceConnection, connection);
    }
    async stop() {
        this.stopped = true;
        const conns = Array.from(this.connectingConnections.values());
        await Promise.allSettled(conns.map(async (conn) => conn.close(false)));
    }
}
exports.SimulatorConnector = SimulatorConnector;
//# sourceMappingURL=SimulatorConnector.js.map